import React from 'react';
import {Draggable} from "react-beautiful-dnd";
import style from './fieldController.scss'

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // change background colour if dragging
    background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle
});
const FieldController = ({field, index}) => {
    const icon = require(`./../icons/${  field.icon ? field.icon : 'file-text.svg'}`);
    let disableAllDrag = false;
    if (window.awcfe_object.isMlActive && window.awcfe_object.ml.isDefault === false) {
        disableAllDrag = true;
    }
    return (
        <Draggable
            key={field.key}
            draggableId={`controller-${field.key}`}
            index={index}
            isDragDisabled={disableAllDrag}
        >
            {(provided, snapshot) => (
                <>
                    <div
                        className={style.field}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={
                            provided.draggableProps
                                .style
                        }
                    >
                        <img src={icon}/> {field.name}

                    </div>
                    {snapshot.isDragging &&
                    <div className={`${style.field} ${style.clone}`}><img src={icon}/> {field.name}</div>}
                </>
            )}
        </Draggable>
    )
}

export default FieldController;


